import type { CreateSharedDriveRequest, SharedDriveResponse } from "@workith/shared";
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Input,
} from "@workith/ui";
import type { ReactNode } from "react";
import { useState } from "react";
import api from "../../lib/api";

interface SharedDriveCreateDialogProps {
  children: ReactNode;
  onCreated: () => void;
}

export function SharedDriveCreateDialog({ children, onCreated }: SharedDriveCreateDialogProps) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (!name.trim()) {
      return;
    }

    setSaving(true);
    try {
      await api.post<CreateSharedDriveRequest, SharedDriveResponse>("/api/shared-drives", {
        name: name.trim(),
        description: description.trim() || null,
      });
      setName("");
      setDescription("");
      setOpen(false);
      onCreated();
    } catch (error) {
      console.error("Failed to create shared drive", error);
      alert(error instanceof Error ? error.message : "Failed to create shared drive");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>공유 드라이브 만들기</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <Input
            value={name}
            onChange={(event) => setName(event.target.value)}
            placeholder="드라이브 이름"
          />
          <Input
            value={description}
            onChange={(event) => setDescription(event.target.value)}
            placeholder="설명"
          />
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => setOpen(false)}>
            취소
          </Button>
          <Button type="button" onClick={submit} disabled={!name.trim() || saving}>
            만들기
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
